



















































































import Vue, { PropType } from "vue";
import { HealthPocMetric, HealthPocViewModel } from "@/utils/healthPocViewAdapter";
import HealthMetricCard from "./HealthMetricCard.vue";
import {
  emptyMetric,
  formatDuration,
  formatMetricUnit,
  formatMetricValue,
  iconForMetric,
  measuredAtLabel,
  metricByKey,
  recoveryCards,
  toneForMetric
} from "../healthPagePresentation";

export default Vue.extend({
  name: "HealthSleepPanel",
  components: { HealthMetricCard },
  props: {
    view: { type: Object as PropType<HealthPocViewModel>, required: true },
    providerLabel: { type: String, required: true }
  },
  computed: {
    sleepMetric(): HealthPocMetric {
      return metricByKey(this.view, "sleep") || emptyMetric("sleep", "Sono", "min");
    },
    recoveryCards() {
      return recoveryCards(this.view);
    },
    additionalSections() {
      return this.view.sections.filter(section => section.key !== "known-metrics");
    }
  },
  methods: {
    formatSleepMetric(metric: HealthPocMetric): string {
      return formatDuration(metric.value);
    },
    formatMetricUnit,
    formatMetricValue,
    iconForMetric,
    measuredAtLabel,
    toneForMetric
  }
});
